var exports = {
  "Q": "xcc377c0b--3c59f1--content",
};

module.exports = exports;
